import React, { ComponentProps } from 'react';
import SetupItem from '../../../../../../components/Dashboard/getting-started/accordion/SetupItem';
import { IonAccordion } from '@ionic/react';
import AccordionHeader from '../../../../../../components/Dashboard/getting-started/accordion/AccordionHeader';
import { Controller, useFormContext } from 'react-hook-form';
import z from 'zod';
import { StorePrimaryInfo } from '../../../../../../schemas/storeGetStartedSchema';
import { IonicButton } from 'ionic-ui';
import PhoneNumberInput from '../../../../../../components/ui/PhoneNumberInput';

type Props = {
  onSave: () => Promise<void> | void;
} & ComponentProps<typeof IonAccordion>;
export default function StoreInfoAccordion({
  onSave,
  value = 'Store-information',
  ...res
}: Props) {
  const {
    control,
    formState: { errors, isDirty },
  } = useFormContext<z.infer<typeof StorePrimaryInfo>>();

  return (
    <IonAccordion value={value} {...res}>
      <AccordionHeader>Store information</AccordionHeader>
      <div
        slot="content"
        className="flex flex-col p-4 gap-4 bg-background dark:bg-background-accent"
      >
        <Controller
          control={control}
          name="name"
          render={({ field }) => (
            <SetupItem
              {...field}
              label="Store Name*"
              placeholder="e.g. Health Plus Pharmacy"
              fieldType="text"
              hint={errors.name?.message}
            />
          )}
        />
        <Controller
          control={control}
          name="contact_email"
          render={({ field }) => (
            <SetupItem
              {...field}
              value={field.value ?? ''}
              label="Store Email"
              placeholder="e.g. storename@gmail.com"
              fieldType="text"
              hint={errors.contact_email?.message}
            />
          )}
        />

        <Controller
          control={control}
          name="contact_phone"
          render={({ field }) => (
            <PhoneNumberInput
              {...field}
              variant="filled"
              label="Store Phone Number"
              size="lg"
              placeholder="e.g. 0801 234 5678"
              hint={errors.contact_phone?.message}
              hintClass="text-red-600 dark:text-red-600"
            />
          )}
        />
        <Controller
          control={control}
          name="description"
          render={({ field }) => (
            <SetupItem
              {...field}
              label="store Description*"
              className="resize-none"
              fieldType="textarea"
              placeholder="e.g. Briefly describe what your store offers and what makes it unique"
              hint={errors.description?.message}
            />
          )}
        />
        <Controller
          control={control}
          name="address"
          render={({ field }) => (
            <SetupItem
              {...field}
              label="Store Address*"
              fieldType="text"
              placeholder="e.g. 42 Health Way, Lagos State"
              hint={errors.address?.message}
            />
          )}
        />
        <div className="py-4">
          <IonicButton
            type="button"
            onClick={onSave}
            disabled={!isDirty}
            className="w-full rounded-sm"
          >
            Save
          </IonicButton>
        </div>
      </div>
    </IonAccordion>
  );
}
